import { post, get, request } from "./http.js";
//公共接口
/**
 * 登录接口
 * @param {*} data 
 * @returns 
 */
const indexLogin = (data) => post("index/login", data);
/**
 * 编辑当前账号信息（只针对渠道用户）
 * @param {*} data 
 * @returns 
 */
const indexEditinfo = (data) => post("index/editinfo", data);
/**
 * 得到所有城市
 * @param {*} data 
 * @returns 
 */
const indexGetcity = (data) => post("index/getcity", data);
/**
 * 上传图片处理
 * @param {*} data 
 * @returns 
 */
const indexUploadimg = (data) => post("index/uploadimg", data);
/**
 * 上传文件处理
 * @param {*} data 
 * @returns 
 */
const indexUploadfile = (data) => post("index/uploadfile", data);
/**
 * 得到当前账户信息
 * @param {*} data 
 * @returns 
 */
const indexGetinfo = (data) => post("index/getinfo", data);
/**
 * 忘记密码 验证手机号
 * @param {*} data 
 * @returns 
 */
const indexForgetcheckphone = (data) => post("index/forgetcheckphone", data);
/**
 * 忘记密码 重置密码
 * @param {*} data 
 * @returns 
 */
const indexReset = (data) => post("index/reset", data);
/**
 * 发送验证码
 * @param {*} data 
 * @returns 
 */
const indexSendcode = (data) => post("index/sendcode", data);
//首页
/**
 * 工作台
 * @param {*} data 
 * @returns 
 */
const indexWorkbench = (data) => post("index/workbench", data);
/**
 * 工作台-实时统计板块（10分钟请求一次）
 * @param {*} data 
 * @returns 
 */
const indexUpdateaddup = (data) => post("index/updateaddup", data);
/**
 * 登录日志
 * @param {*} data 
 * @returns 
 */
const indexLoginlog = (data) => post("index/loginlog", data);

//基础业务
//月嫂管理
/**
 * 月嫂列表
 * @param {*} data 
 * @returns 
 */
const yuesaoLst = (data) => post("yuesao/lst", data);
/**
 * 得到渠道下拉
 * @param {*} data 
 * @returns 
 */
const yuesaoGetchannel = (data) => post("yuesao/getchannel", data);
/**
 * 得到介绍人下拉
 * @param {*} data 
 * @returns 
 */
const yuesaoGetpinfo = (data) => post("yuesao/getpinfo", data);
/**
 * 月嫂详情
 * @param {*} data 
 * @returns 
 */
const yuesaoDetail = (data) => post("yuesao/detail", data);
/**
 * 新增编辑月嫂
 * @param {*} data 
 * @returns 
 */
const yuesaoEdit = (data) => post("yuesao/edit", data);
/**
 * 转移介绍人 单个、批量
 * @param {*} data 
 * @returns 
 */
const yuesaoMovepid = (data) => post("yuesao/movepid", data);
/**
 * 转移渠道 单个、批量
 * @param {*} data 
 * @returns 
 */
const yuesaoMovechannel = (data) => post("yuesao/movechannel", data);
/**
 * 停止合作
 * @param {*} data 
 * @returns 
 */
const yuesaoStopcooperation = (data) => post("yuesao/stopcooperation", data);
/**
 * 停止合作的月嫂 继续合作 单个、批量
 * @param {*} data 
 * @returns 
 */
const yuesaoKeepcooperation = (data) => post("yuesao/keepcooperation", data);
/**
 * 停止合作的月嫂 删除 单个、批量
 * @param {*} data 
 * @returns 
 */
const yuesaoDel = (data) => post("yuesao/del", data);
/**
 * 异常操作 新增编辑违规记录
 * @param {*} data 
 * @returns 
 */
const yuesaoEditderegulation = (data) => post("yuesao/editderegulation", data);
/**
 * 违规记录列表
 * @param {*} data 
 * @returns 
 */
const yuesaoDeregulationlist = (data) => post("yuesao/deregulationlist", data);
/**
 * 撤销违规记录
 * @param {*} data 
 * @returns 
 */
const yuesaoCancelderegulation = (data) => post("yuesao/cancelderegulation", data);
/**
 * 删除违规记录
 * @param {*} data 
 * @returns 
 */
const yuesaoDelderegulation = (data) => post("yuesao/delderegulation", data);
/**
 * 操作记录
 * @param {*} data 
 * @returns 
 */
const yuesaoOperatelog = (data) => post("yuesao/operatelog", data);
/**
 * 下级月嫂
 * @param {*} data 
 * @returns 
 */
const yuesaoChildyuesao = (data) => post("yuesao/childyuesao", data);
/**
 * 月嫂管理 任务记录
 * @param {*} data 
 * @returns 
 */
const yuesaoTasklog = (data) => post("yuesao/tasklog", data);
/**
 * 月嫂管理 客户列表
 * @param {*} data 
 * @returns 
 */
const yuesaoUserlist = (data) => post("yuesao/userlist", data);
/**
 * 月嫂管理 佣金记录
 * @param {*} data 
 * @returns 
 */
const yuesaoCommissionlog = (data) => post("yuesao/commissionlog", data);
/**
 * 月嫂管理 福利兑换
 * @param {*} data 
 * @returns 
 */
const yuesaoCheckorderlist = (data) => post("yuesao/checkorderlist", data);
/**
 * 月嫂管理 活动记录
 * @param {*} data 
 * @returns 
 */
const yuesaoActivitylog = (data) => post("yuesao/activitylog", data);
/**
 * 月嫂管理 审核驳回
 * @param {*} data 
 * @returns 
 */
const yuesaoBohui = (data) => post("yuesao/bohui", data);
/**
 * 月嫂管理 审核通过单个、批量
 * @param {*} data 
 * @returns 
 */
const yuesaoShenhepass = (data) => post("yuesao/shenhepass", data);

//客户管理
/**
 * 客户列表
 * @param {*} data 
 * @returns 
 */
const userLst = (data) => post("user/lst", data);
/**
 * 得到客服列表数据（追踪人列表)
 * @param {*} data 
 * @returns 
 */
const userKefulist = (data) => post("user/kefulist", data);
/**
 * 客户详情
 * @param {*} data 
 * @returns 
 */
const userDetail = (data) => post("user/detail", data);
/**
 * 新增编辑客户
 * @param {*} data 
 * @returns 
 */
const userEdit = (data) => post("user/edit", data);
/**
 * 单个批量设置禁用、启用
 * @param {*} data 
 * @returns 
 */
const userSetstatus = (data) => post("user/setstatus", data);
/**
 * 操作记录
 * @param {*} data 
 * @returns 
 */
const userOperatelog = (data) => post("user/operatelog", data);
/**
 * 得到介绍人下拉
 * @param {*} data 
 * @returns 
 */
const userGetpinfo = (data) => post("user/getpinfo", data);
/**
 * 客户管理 佣金记录
 * @param {*} data 
 * @returns 
 */
const userCommissionlog = (data) => post("user/commissionlog", data);
/**
 * 客户管理 商城订单列表
 * @param {*} data 
 * @returns 
 */
const userOrderlist = (data) => post("user/orderlist", data);
/**
 * 客户管理 客户分配
 * @param {*} data 
 * @returns 
 */
const userDistribute = (data) => post("user/distribute", data);
/**
 * 客户管理 邀约上门
 * @param {*} data 
 * @returns 
 */
const userInvitedoor = (data) => post("user/invitedoor", data);
/**
 * 客户管理 邀约记录
 * @param {*} data 
 * @returns 
 */
const userInvitelog = (data) => post("user/invitelog", data);
/**
 * 客户管理 得到邀约失败原因
 * @param {*} data 
 * @returns 
 */
const dictionaryGetinvite = (data) => post("dictionary/getinvite", data);

//任务中心
/**
 * 任务中心 列表
 * @param {*} data 
 * @returns 
 */
const taskLst = (data) => post("task/lst", data);
/**
 * 任务中心 任务详情
 * @param {*} data 
 * @returns 
 */
const taskDetail = (data) => post("task/detail", data);
/**
 * 任务中心 新增编辑（再次发布）
 * @param {*} data 
 * @returns 
 */
const taskEdit = (data) => post("task/edit", data);
/**
 * 任务中心 批量作废 只有待发布状态下才能批量作废
 * @param {*} data 
 * @returns 
 */
const taskCancel = (data) => post("task/cancel", data);
/**
 * 任务中心 批量恢复 只有已作废状态下才能批量恢复
 * @param {*} data 
 * @returns 
 */
const taskRecovery = (data) => post("task/recovery", data);
/**
 * 任务中心 批量删除 进行中的任务不能操作
 * @param {*} data 
 * @returns 
 */
const taskDel = (data) => post("task/del", data);
/**
 * 任务中心 操作记录
 * @param {*} data 
 * @returns 
 */
const taskOperatelog = (data) => post("task/operatelog", data);
/**
 * 任务中心 批量发布 只有待发布状态下才能批量发布
 * @param {*} data 
 * @returns 
 */
const taskRelease = (data) => post("task/release", data);
/**
 * 任务中心 任务已完成、未完成人数
 * @param {*} data 
 * @returns 
 */
const taskGettasklog = (data) => post("task/gettasklog", data);
//活动管理
/**
 * 活动管理 列表
 * @param {*} data 
 * @returns 
 */
const activityLst = (data) => post("activity/lst", data);
/**
 * 活动管理 详情
 * @param {*} data 
 * @returns 
 */
const activityDetail = (data) => post("activity/detail", data);
/**
 * 活动管理 新增编辑
 * @param {*} data 
 * @returns 
 */
const activityEdit = (data) => post("activity/edit", data);
/**
 * 活动管理 批量发布 只有待发布状态下才能批量发布
 * @param {*} data 
 * @returns 
 */
const activityRelease = (data) => post("activity/release", data);
/**
 * 活动管理 批量删除 只有待发布状态下才能批量删除
 * @param {*} data 
 * @returns 
 */
const activityDel = (data) => post("activity/del", data);
/**
 * 活动管理 审核
 * @param {*} data 
 * @returns 
 */
const activityExamine = (data) => post("activity/examine", data);
/**
 * 活动管理 批量撤回 只有报名中状态下才能批量撤回
 * @param {*} data 
 * @returns 
 */
const activityRecall = (data) => post("activity/recall", data);
/**
 * 活动管理 批量结束活动 只有报名截止状态下才能批量结束
 * @param {*} data 
 * @returns 
 */
const activitySetover = (data) => post("activity/setover", data);
/**
 * 活动管理 参加人员
 * @param {*} data 
 * @returns 
 */
const activityJoinlist = (data) => post("activity/joinlist", data);
/**
 * 活动管理 操作记录
 * @param {*} data 
 * @returns 
 */
const activityOperatelog = (data) => post("activity/operatelog", data);
/**
 * 活动管理 活动类型
 * @param {*} data 
 * @returns 
 */
const dictionaryGetactivitytype = (data) => post("dictionary/getactivitytype", data);
/**
 * 活动管理 生成活动签到小程序码 base64图片
 * @param {*} data 
 * @returns 
 */
const activitySetqrcode = (data) => post("activity/setqrcode", data);
/**
 * 活动管理 批量签到
 * @param {*} data 
 * @returns 
 */
const activitySetsign = (data) => post("activity/setsign", data);
/**
 * 活动管理 批量取消报名
 * @param {*} data 
 * @returns 
 */
const activityCanceljoin = (data) => post("activity/canceljoin", data);

//门店渠道
/**
 * 门店渠道 列表
 * @param {*} data 
 * @returns 
 */
const channelLst = (data) => post("channel/lst", data);
/**
 * 门店渠道 详情
 * @param {*} data 
 * @returns 
 */
const channelDetail = (data) => post("channel/detail", data);
/**
 * 门店渠道 新增编辑
 * @param {*} data 
 * @returns 
 */
const channelEdit = (data) => post("channel/edit", data);
/**
 * 门店渠道 停止合作
 * @param {*} data 
 * @returns 
 */
const channelStopcooperation = (data) => post("channel/stopcooperation", data);
/**
 * 门店渠道 继续合作
 * @param {*} data 
 * @returns 
 */
const channelCancel = (data) => post("channel/cancel", data);
/**
 * 门店渠道 操作记录
 * @param {*} data 
 * @returns 
 */
const channelOperatelog = (data) => post("channel/operatelog", data);
/**
 * 门店渠道 佣金记录
 * @param {*} data 
 * @returns 
 */
const channelCommissionlog = (data) => post("channel/commissionlog", data);
/**
 * 门店渠道 商城订单列表
 * @param {*} data 
 * @returns 
 */
const channelOrderlist = (data) => post("channel/orderlist", data);

//学习园地
/**
 * 学习园地 列表
 * @param {*} data 
 * @returns 
 */
const studyLst = (data) => post("study/lst", data);
/**
 * 学习园地 详情
 * @param {*} data 
 * @returns 
 */
const studyDetail = (data) => post("study/detail", data);
/**
 * 学习园地 新增编辑
 * @param {*} data 
 * @returns 
 */
const studyEdit = (data) => post("study/edit", data);
/**
 * 学习园地 批量删除
 * @param {*} data 
 * @returns 
 */
const studyDel = (data) => post("study/del", data);

//爱心帮扶
/**
 * 爱心帮扶 列表
 * @param {*} data 
 * @returns 
 */
const helpLst = (data) => post("help/lst", data);
/**
 * 爱心帮扶 处理
 * @param {*} data 
 * @returns 
 */
const helpHandle = (data) => post("help/handle", data);
/**
 * 爱心帮扶 得到帮扶类型
 * @param {*} data 
 * @returns 
 */
const dictionaryGethelptype = (data) => post("dictionary/gethelptype", data);
/**
 * 爱心帮扶 详情
 * @param {*} data 
 * @returns 
 */
const helpDetail = (data) => post("help/detail", data);
/**
 * 爱心帮扶 处理过程
 * @param {*} data 
 * @returns 
 */
const helpHandlelist = (data) => post("help/handlelist", data);
//云暖商城
//商品管理
/**
 * 商品管理 商品列表
 * @param {*} data 
 * @returns 
 */
const shopGoodslist = (data) => post("shop/goodslist", data);
/**
 * 商品管理 新增编辑
 * @param {*} data 
 * @returns 
 */
const shopGoodsedit = (data) => post("shop/goodsedit", data);
/**
 * 商品管理 商品详情
 * @param {*} data 
 * @returns 
 */
const shopGoodsdetail = (data) => post("shop/goodsdetail", data);
/**
 * 商品管理 得到系统商品规格
 * @param {*} data 
 * @returns 
 */
const shopAttrlist = (data) => post("shop/attrlist", data);
/**
 * 商品管理 新增系统规格
 * @param {*} data 
 * @returns 
 */
const shopAttredit = (data) => post("shop/attredit", data);
/**
 * 商品管理 商品批量上架下架
 * @param {*} data 
 * @returns 
 */
const shopGoodsstatus = (data) => post("shop/goodsstatus", data);
/**
 * 商品管理 商品批量删除
 * @param {*} data 
 * @returns 
 */
const shopGoodsdel = (data) => post("shop/goodsdel", data);
/**
 * 商品管理 得到商品适合年龄段

 * @param {*} data 
 * @returns 
 */
const dictionaryGetage = (data) => post("dictionary/getage", data);

//商品类目
/**
 * 商品类目 商品类目列表
 * @param {*} data 
 * @returns 
 */
const shopcatelist = (data) => post("shop/catelist", data);
/**
 * 商品类目 根据条件获取对应类目
 * @param {*} data 
 * @returns 
 */
const shopGetcate = (data) => post("shop/getcate", data);
/**
 * 商品类目 类目新增编辑
 * @param {*} data 
 * @returns 
 */
const shopCateedit = (data) => post("shop/cateedit", data);
/**
 * 商品类目 类目禁用显示
 * @param {*} data 
 * @returns 
 */
const shopCatestatus = (data) => post("shop/catestatus", data);
/**
 * 商品类目 商品类目批量删除

 * @param {*} data 
 * @returns 
 */
const shopCatedel = (data) => post("shop/catedel", data);
/**
 * 商品类目 商品类目批量导入

 * @param {*} data 
 * @returns 
 */
const shopImportcate = (data) => post("shop/importcate", data);
//订单管理
/**
 * 订单管理 订单列表

 * @param {*} data 
 * @returns 
 */
const shopOrderlist = (data) => post("shop/orderlist", data);
/**
 * 订单管理 订单详情

 * @param {*} data 
 * @returns 
 */
const shopOrderdetail = (data) => post("shop/orderdetail", data);
/**
 * 订单管理 待付款订单 取消订单

 * @param {*} data 
 * @returns 
 */
const shopOrdercancel = (data) => post("shop/ordercancel", data);
/**
 * 订单管理 待发货订单发货

 * @param {*} data 
 * @returns 
 */
const shopOrdersend = (data) => post("shop/ordersend", data);
/**
 * 订单管理 修改物流

 * @param {*} data 
 * @returns 
 */
const shopOrderresend = (data) => post("shop/orderresend", data);
/**
 * 订单管理 某件商品的所有评价

 * @param {*} data 
 * @returns 
 */
const shopEvaluatelist = (data) => post("shop/evaluatelist", data);
/**
 * 订单管理 得到物流公司

 * @param {*} data 
 * @returns 
 */
const dictionaryGetexpress = (data) => post("dictionary/getexpress", data);
//售后订单
/**
 * 售后订单 订单列表

 * @param {*} data 
 * @returns 
 */
const shopRefundorderlist = (data) => post("shop/refundorderlist", data);
/**
 * 售后订单 退款订单详情
 * @param {*} data 
 * @returns 
 */
const shopRefundorderdetail = (data) => post("shop/refundorderdetail", data);
/**
 * 售后订单 待处理售后订单 同意拒绝退款
 * @param {*} data 
 * @returns 
 */
const shopRefundhandle = (data) => post("shop/refundhandle", data);
/**
 * 售后订单 用户退回商品 商家后台确认到货
 * @param {*} data 
 * @returns 
 */
const shopRefundconfirmgetgoods = (data) => post("shop/refundconfirmgetgoods", data);
/**
 * 售后订单 退款中售后订单 商家同意或拒绝退款
 * @param {*} data 
 * @returns 
 */
const shopRefundgetgoodshandle = (data) => post("shop/refundgetgoodshandle", data);
//福利核销
/**
 * 福利核销 列表
 * @param {*} data 
 * @returns 
 */
const shopCheckorderlist = (data) => post("shop/checkorderlist", data);
/**
 * 福利核销 待核销卡券核销 （兑换码核销）
 * @param {*} data 
 * @returns 
 */
const shopSetcheck = (data) => post("shop/setcheck", data);
/**
 * 福利核销 已作废卡券恢复
 * @param {*} data 
 * @returns 
 */
const shopCheckorderrecovery = (data) => post("shop/checkorderrecovery", data);
//营销设置
/**
 * 限时秒杀 列表
 * @param {*} data 
 * @returns 
 */
const shopSeckilllist = (data) => post("shop/seckilllist", data);
/**
 * 限时秒杀 设置秒杀产品
 * @param {*} data 
 * @returns 
 */
const shopAddseckill = (data) => post("shop/addseckill", data);
/**
 * 限时秒杀 编辑秒杀产品
 * @param {*} data 
 * @returns 
 */
const shopEditseckill = (data) => post("shop/editseckill", data);
/**
 * 限时秒杀 批量设置秒杀产品启用禁用
 * @param {*} data 
 * @returns 
 */
const shopSetseckillstatus = (data) => post("shop/setseckillstatus", data);
/**
 * 限时秒杀 批量删除秒杀产品记录
 * @param {*} data 
 * @returns 
 */
const shopSeckilldel = (data) => post("shop/seckilldel", data);

/**
 * 新人专享 列表
 * @param {*} data 
 * @returns 
 */
const shopNewlist = (data) => post("shop/newlist", data);
/**
 * 新人专享 设置新人专享产品
 * @param {*} data 
 * @returns 
 */
const shopAddnew = (data) => post("shop/addnew", data);
/**
 * 新人专享 编辑新人专享产品
 * @param {*} data 
 * @returns 
 */
const shopEditnew = (data) => post("shop/editnew", data);
/**
 * 新人专享 批量设置新人专享产品启用禁用
 * @param {*} data 
 * @returns 
 */
const shopSetnewstatus = (data) => post("shop/setnewstatus", data);
/**
 * 新人专享 批量删除新人专享产品记录
 * @param {*} data 
 * @returns 
 */
const shopNewdel = (data) => post("shop/newdel", data);

/**
 * 9.9包邮 列表
 * @param {*} data 
 * @returns 
 */
const shopNofeelist = (data) => post("shop/nofeelist", data);
/**
 * 9.9包邮 设置9.9包邮产品
 * @param {*} data 
 * @returns 
 */
const shopAddnofee = (data) => post("shop/addnofee", data);
/**
 * 9.9包邮 编辑9.9包邮产品
 * @param {*} data 
 * @returns 
 */
const shopEditnofee = (data) => post("shop/editnofee", data);
/**
 * 9.9包邮 批量设置9.9包邮产品启用禁用
 * @param {*} data 
 * @returns 
 */
const shopSetnofeestatus = (data) => post("shop/setnofeestatus", data);
/**
 * 9.9包邮 批量删除9.9包邮产品记录
 * @param {*} data 
 * @returns 
 */
const shopNofeedel = (data) => post("shop/nofeedel", data);

//小程序轮播图
/**
 * 小程序轮播图 列表
 * @param {*} data 
 * @returns 
 */
const shopBannerlist = (data) => post("shop/bannerlist", data);
/**
 * 小程序轮播图 新增编辑banner
 * @param {*} data 
 * @returns 
 */
const shopEditbanner = (data) => post("shop/editbanner", data);
/**
 * 小程序轮播图 详情
 * @param {*} data 
 * @returns 
 */
const shopBannerdetail = (data) => post("shop/bannerdetail", data);
/**
 * 小程序轮播图 banner批量删除
 * @param {*} data 
 * @returns 
 */
const shopBannerdel = (data) => post("shop/bannerdel", data);
/**
 * 小程序轮播图 批量设置banner状态
 * @param {*} data 
 * @returns 
 */
const shopSetbannerstatus = (data) => post("shop/setbannerstatus", data);

/**
 * 会员设置 列表
 * @param {*} data 
 * @returns 
 */
const shopViplist = (data) => post("shop/viplist", data);
/**
 * 会员设置 编辑会员等级
 * @param {*} data 
 * @returns 
 */
const shopEipedit = (data) => post("shop/vipedit", data);

/**
 * 优惠券管理 列表
 * @param {*} data 
 * @returns 
 */
const couponLst = (data) => post("coupon/lst", data);
/**
 * 优惠券管理 详情
 * @param {*} data 
 * @returns 
 */
const couponDetail = (data) => post("coupon/detail", data);
/**
 * 优惠券管理 新增编辑
 * @param {*} data 
 * @returns 
 */
const couponEdit = (data) => post("coupon/edit", data);
/**
 * 优惠券管理 批量设置状态
 * @param {*} data 
 * @returns 
 */
const couponSetstatus = (data) => post("coupon/setstatus", data);
/**
 * 优惠券管理 批量删除
 * @param {*} data 
 * @returns 
 */
const couponDel = (data) => post("coupon/del", data);

/**
 * 公告管理 列表
 * @param {*} data 
 * @returns 
 */
const noticeLst = (data) => post("notice/lst", data);
/**
 * 公告管理 详情
 * @param {*} data 
 * @returns 
 */
const noticeDetail = (data) => post("notice/detail", data);
/**
 * 公告管理 新增编辑
 * @param {*} data 
 * @returns 
 */
const noticeEdit = (data) => post("notice/edit", data);
/**
 * 公告管理 批量删除
 * @param {*} data 
 * @returns 
 */
const noticeDel = (data) => post("notice/del", data);

//系统设置
//角色授权
/**
 * 角色授权 角色及对应权限菜单
 * @param {*} data 
 * @returns 
 */
const authorizeLst = (data) => post("authorize/lst", data);
/**
 * 角色授权 得到所有的系统权限
 * @param {*} data 
 * @returns 
 */
const authorizeGetallmenu = (data) => post("authorize/getallmenu", data);
/**
 * 角色授权 新增编辑角色
 * @param {*} data 
 * @returns 
 */
const authorizeEdit = (data) => post("authorize/edit", data);
/**
 * 角色授权 删除角色
 * @param {*} data 
 * @returns 
 */
const authorizeDel = (data) => post("authorize/del", data);
/**
 * 角色授权 给相应角色分配菜单权限
 * @param {*} data 
 * @returns 
 */
const authorizeSetmenu = (data) => post("authorize/setmenu", data);

/**
 * 员工账号 列表
 * @param {*} data 
 * @returns 
 */
const adminLst = (data) => post("admin/lst", data);
/**
 * 员工账号 新增编辑信息
 * @param {*} data 
 * @returns 
 */
const adminEdit = (data) => post("admin/edit", data);
/**
 * 员工账号 详情
 * @param {*} data 
 * @returns 
 */
const adminDetail = (data) => post("admin/detail", data);
/**
 * 员工账号 批量、单个删除
 * @param {*} data 
 * @returns 
 */
const adminDel = (data) => post("admin/del", data);
/**
 * 员工账号 批量、单个启用 禁用
 * @param {*} data 
 * @returns 
 */
const adminSetstatus = (data) => post("admin/setstatus", data);
/**
 * 员工账号 得到可选角色
 * @param {*} data 
 * @returns 
 */
const adminGetrole = (data) => post("admin/getrole", data);
//积分管理
/**
 * 积分管理 配置数据
 * @param {*} data 
 * @returns 
 */
const integralSetconfig = (data) => post("integral/setconfig", data);
/**
 * 积分管理 得到配置
 * @param {*} data 
 * @returns 
 */
const integralGetconfig = (data) => post("integral/getconfig", data);

//数据字典
/**
 * 数据字典 参数名列表
 * @param {*} data 
 * @returns 
 */
const dictionaryParamlist = (data) => post("dictionary/paramlist", data);
/**
 * 数据字典 参数值列表
 * @param {*} data 
 * @returns 
 */
const dictionaryValuelist = (data) => post("dictionary/valuelist", data);
/**
 * 数据字典 新增编辑参数值信息
 * @param {*} data 
 * @returns 
 */
const dictionaryEditvalue = (data) => post("dictionary/editvalue", data);
/**
 * 数据字典 批量、单个删除
 * @param {*} data 
 * @returns 
 */
const dictionaryDel = (data) => post("dictionary/del", data);
/**
 * 数据字典 批量、单个启用 禁用
 * @param {*} data 
 * @returns 
 */
const dictionarySetstatus = (data) => post("dictionary/setstatus", data);
//活跃度设置
/**
 * 活跃度设置 配置数据
 * @param {*} data 
 * @returns 
 */
const activerateSetconfig = (data) => post("activerate/setconfig", data);
/**
 * 活跃度设置 得到配置
 * @param {*} data 
 * @returns 
 */
const activerateGetconfig = (data) => post("activerate/getconfig", data);
//活动免责声明
/**
 * 活动免责声明 配置数据
 * @param {*} data 
 * @returns 
 */
const activerateSetshengming = (data) => post("activerate/setshengming", data);
/**
 * 活动免责声明 得到配置
 * @param {*} data 
 * @returns 
 */
const activerateGetshengming = (data) => post("activerate/getshengming", data);

//分销管理
/**
 * 分销设置 得到开通城市
 * @param {*} data 
 * @returns 
 */
const fenxiaoGetopencity = (data) => post("fenxiao/getopencity", data);
/**
 * 分销设置 开通启用城市
 * @param {*} data 
 * @returns 
 */
const fenxiaoOpencity = (data) => post("fenxiao/opencity", data);
/**
 * 分销设置 分销配置
 * @param {*} data 
 * @returns 
 */
const fenxiaoSetfenxiaoconfig = (data) => post("fenxiao/setfenxiaoconfig", data);
/**
 * 分销设置 根据城市获取分销配置数据
 * @param {*} data 
 * @returns 
 */
const fenxiaoGetfenxiaoconfig = (data) => post("fenxiao/getfenxiaoconfig", data);


/**
 * 分销设置 列表
 * @param {*} data 
 * @returns 
 */
const fenxiaoCustomizelist = (data) => post("fenxiao/customizelist", data);
/**
 * 分销设置 新增自定义产品佣金
 * @param {*} data 
 * @returns 
 */
const fenxiaoAddcustomize = (data) => post("fenxiao/addcustomize", data);
/**
 * 分销设置 编辑自定义佣金
 * @param {*} data 
 * @returns 
 */
const fenxiaoEditcustomize = (data) => post("fenxiao/editcustomize", data);
/**
 * 分销设置 自定义佣金记录删除
 * @param {*} data 
 * @returns 
 */
const fenxiaoDelcustomize = (data) => post("fenxiao/delcustomize", data);

/**
 * 分销订单 影楼佣金订单列表
 * @param {*} data 
 * @returns 
 */
const fenxiaoCommissionyingloulist = (data) => post("fenxiao/commissionyingloulist", data);
/**
 * 分销订单 影楼佣金订单 新增编辑
 * @param {*} data 
 * @returns 
 */
const fenxiaoCommissionyinglouedit = (data) => post("fenxiao/commissionyinglouedit", data);
/**
 * 分销订单 影楼佣金订单详情
 * @param {*} data 
 * @returns 
 */
const fenxiaoCommissionyingloudetail = (data) => post("fenxiao/commissionyingloudetail", data);
/**
 * 分销订单 影楼佣金订单 删除
 * @param {*} data 
 * @returns 
 */
const fenxiaoCommissionyingloudel = (data) => post("fenxiao/commissionyingloudel", data);
/**
 * 分销订单 商城佣金分销订单列表
 * @param {*} data 
 * @returns 
 */
const fenxiaoCommissionshoplist = (data) => post("fenxiao/commissionshoplist", data);


/**
 * 佣金提现 列表
 * @param {*} data 
 * @returns 
 */
const fenxiaoCashoutlist = (data) => post("fenxiao/cashoutlist", data);
/**
 * 佣金提现 提现审核
 * @param {*} data 
 * @returns 
 */
const fenxiaoCashoutexamine = (data) => post("fenxiao/cashoutexamine", data);
/**
 * 佣金提现 上传凭证
 * @param {*} data 
 * @returns 
 */
const fenxiaoCashoutupload = (data) => post("fenxiao/cashoutupload", data);
/**
 * 佣金提现 对提现失败记录 重新发起提现
 * @param {*} data 
 * @returns 
 */
const fenxiaoResetcashout = (data) => post("fenxiao/resetcashout", data);
/**
 * 佣金提现 提现记录详情
 * @param {*} data 
 * @returns 
 */
const fenxiaoCashoutdetail = (data) => post("fenxiao/cashoutdetail", data);
/**
 * 佣金提现 提现详情 分销订单列表
 * @param {*} data 
 * @returns 
 */
const fenxiaoCashoutorderlist = (data) => post("fenxiao/cashoutorderlist", data);
/**
 * 佣金提现 佣金提现操作记录
 * @param {*} data 
 * @returns 
 */
const fenxiaoOperatelog = (data) => post("fenxiao/operatelog", data);
/**
 * 订单管理 流信息
 * @param {*} data 
 * @returns 
 */
const shopExpressinfo = (data) => post("shop/expressinfo", data);
//新增的接口
/**
 * 分销员管理 列表
 * @param {*} data 
 * @returns 
 */
const salerLst = (data) => post("saler/lst", data);
/**
 * 分销员管理 得到渠道下拉
 * @param {*} data 
 * @returns 
 */
const salerGetchannel = (data) => post("saler/getchannel", data);
/**
 * 分销员管理 得到介绍人下拉
 * @param {*} data 
 * @returns 
 */
const salerGetpinfo = (data) => post("saler/getpinfo", data);
/**
 * 分销员管理 分销员详情
 * @param {*} data 
 * @returns 
 */
const salerDetail = (data) => post("saler/detail", data);
/**
 * 分销员管理 编辑分销员
 * @param {*} data 
 * @returns 
 */
const salerEdit = (data) => post("saler/edit", data);
/**
 * 分销员管理 转移介绍人 单个、批量
 * @param {*} data 
 * @returns 
 */
const salerMovepid = (data) => post("saler/movepid", data);
/**
 * 分销员管理 转移渠道 单个、批量
 * @param {*} data 
 * @returns 
 */
const salerMovechannel = (data) => post("saler/movechannel", data);
/**
 * 分销员管理 停止合作
 * @param {*} data 
 * @returns 
 */
const salerStopcooperation = (data) => post("saler/stopcooperation", data);
/**
 * 分销员管理 审核驳回
 * @param {*} data 
 * @returns 
 */
const salerBohui = (data) => post("saler/bohui", data);
/**
 * 分销员管理 审核通过单个、批量
 * @param {*} data 
 * @returns 
 */
const salerShenhepass = (data) => post("saler/shenhepass", data);

/**
 * 分销员管理 停止合作的分销员 继续合作 单个、批量
 * @param {*} data 
 * @returns 
 */
const salerKeepcooperation = (data) => post("saler/keepcooperation", data);
/**
 * 分销员管理 停止合作的分销员 删除 单个、批量
 * @param {*} data 
 * @returns 
 */
const salerDel = (data) => post("saler/del", data);
/**
 * 分销员管理 新增编辑违规记录
 * @param {*} data 
 * @returns 
 */
const salerEditderegulation = (data) => post("saler/editderegulation", data);
/**
 * 分销员管理 违规记录列表
 * @param {*} data 
 * @returns 
 */
const salerDeregulationlist = (data) => post("saler/deregulationlist", data);
/**
 * 分销员管理 删除违规记录
 * @param {*} data 
 * @returns 
 */
const salerDelderegulation = (data) => post("saler/delderegulation", data);
/**
 * 分销员管理 撤销违规记录
 * @param {*} data 
 * @returns 
 */
const salerCancelderegulation = (data) => post("saler/cancelderegulation", data);
/**
 * 分销员管理 客户列表
 * @param {*} data 
 * @returns 
 */
const salerUserlist = (data) => post("saler/userlist", data);
/**
 * 分销员管理 提现记录
 * @param {*} data 
 * @returns 
 */
const salerCashoutlog = (data) => post("saler/cashoutlog", data);
/**
 * 分销员管理 下级列表 分销员
 * @param {*} data 
 * @returns 
 */
const salerChildlist = (data) => post("saler/childlist", data);
/**
 * 分销员管理 佣金记录
 * @param {*} data 
 * @returns 
 */
const salerCommissionlog = (data) => post("saler/commissionlog", data);
/**
 * 分销员管理 操作记录
 * @param {*} data 
 * @returns 
 */
const salerOperatelog = (data) => post("saler/operatelog", data);
/**
 * 分销员管理 得到银行名称
 * @param {*} data 
 * @returns 
 */
const dictionaryGetbank = (data) => post("dictionary/getbank", data);

/**
 * 消息通知 列表
 * @param {*} data 
 * @returns 
 */
const messageLst = (data) => post("message/lst", data);
/**
 * 消息通知 设为已读
 * @param {*} data 
 * @returns 
 */
const messageSetstatus = (data) => post("message/setstatus", data);
/**
 * 员工账号 成为分销员
 * @param {*} data 
 * @returns 
 */
const adminInvitesaler = (data) => post("admin/invitesaler", data);
/**
 * 售后订单退回货物 查看物流
 * @param {*} data 
 * @returns 
 */
const shopRefundexpressinfo = (data) => post("shop/refundexpressinfo", data);

/**
 * 退货设置 配置数据
 * @param {*} data 
 * @returns 
 */
const refundconfigSetconfig = (data) => post("refundconfig/setconfig", data);
/**
 * 退货设置 得到配置
 * @param {*} data 
 * @returns 
 */
const refundconfigGetconfig = (data) => post("refundconfig/getconfig", data);
/**
 * 退货设置 得到配置
 * @param {*} data 
 * @returns 
 */
const fenxiaoGetaccount = (data) => post("fenxiao/getaccount", data);
/**
 * 客户管理 导入
 * @param {*} data 
 * @returns 
 */
const userImport = (data) => post("user/import", data);
/**
 * 客户管理 得到客户类别下拉
 * @param {*} data 
 * @returns 
 */
const dictionaryGettype = (data) => post("dictionary/gettype", data);
/**
 * 客户管理 邀约成功客户操作成单金额
 * @param {*} data 
 * @returns 
 */
const userSetmoney = (data) => post("user/setmoney", data);
/**
 * 客户管理 标记类别 （待分配客户）
 * @param {*} data 
 * @returns 
 */
const userSettype = (data) => post("user/settype", data);
/**
 * 月嫂管理 导入月嫂
 * @param {*} data 
 * @returns 
 */
const yuesaoImport = (data) => post("yuesao/import", data);
/**
 * 月嫂管理 得到月嫂渠道
 * @param {*} data 
 * @returns 
 */
const dictionaryGetqudao = (data) => post("dictionary/getqudao", data);

/**
 * 月嫂管理 得到所在城市下拉
 * @param {*} data 
 * @returns 
 */
const indexGetselectcity = (data) => post("index/getselectcity", data);
/**
 * 客户管理 客户 删除 单个、批量
 * @param {*} data 
 * @returns 
 */
const userDel = (data) => post("user/del", data);
/**
 * 客户管理 得到客户渠道来源
 * @param {*} data 
 * @returns 
 */
const dictionaryGetsrc = (data) => post("dictionary/getsrc", data);
/**
 * 订单管理 修改分销员 列表分销员参数为空时执行
 * @param {*} data 
 * @returns 
 */
const shopEditsaler = (data) => post("shop/editsaler", data);
/**
 * 订单管理 修改分销员 列表分销员参数不为空时执行
 * @param {*} data 
 * @returns 
 */
const shopEditsaler2 = (data) => post("shop/editsaler2", data);
/**
 * 订单管理 待发货订单 退款
 * @param {*} data 
 * @returns 
 */
const shopAdminrefund = (data) => post("shop/adminrefund", data);
/**
 * 待审核提现记录 变成 已提现
 * @param {*} data 
 * @returns 
 */
const fenxiaoSetcashout = (data) => post("fenxiao/setcashout", data);

export default {
    fenxiaoSetcashout,
    shopAdminrefund,
    shopEditsaler,
    shopEditsaler2,
    indexGetselectcity,
    dictionaryGetqudao,
    dictionaryGetsrc,
    userDel,
    yuesaoImport,
    userSetmoney,
    userSettype,
    dictionaryGettype,
    userImport,
    fenxiaoGetaccount,
    refundconfigSetconfig,
    refundconfigGetconfig,
    shopRefundexpressinfo,
    adminInvitesaler,
    messageLst,
    messageSetstatus,

    salerDelderegulation,
    dictionaryGetbank,
    shopExpressinfo,
    indexLogin,
    indexEditinfo,
    indexGetcity,
    indexUploadimg,
    indexUploadfile,
    indexWorkbench,
    indexLoginlog,
    indexGetinfo,
    indexForgetcheckphone,
    indexReset,
    indexSendcode,

    yuesaoLst,
    yuesaoGetchannel,
    yuesaoGetpinfo,
    yuesaoDetail,
    yuesaoEdit,
    yuesaoMovepid,
    yuesaoMovechannel,
    yuesaoStopcooperation,
    yuesaoKeepcooperation,
    yuesaoDel,
    yuesaoEditderegulation,
    yuesaoDeregulationlist,
    yuesaoCancelderegulation,
    yuesaoDelderegulation,
    yuesaoOperatelog,
    yuesaoChildyuesao,
    yuesaoTasklog,
    yuesaoUserlist,
    yuesaoCommissionlog,
    yuesaoCheckorderlist,
    yuesaoActivitylog,
    yuesaoBohui,
    yuesaoShenhepass,

    userLst,
    userDetail,
    userEdit,
    userSetstatus,
    userOperatelog,
    userGetpinfo,
    userKefulist,
    userDistribute,
    userInvitedoor,
    userInvitelog,
    dictionaryGetinvite,

    taskLst,
    taskDetail,
    taskEdit,
    taskCancel,
    taskRecovery,
    taskDel,
    taskOperatelog,
    taskRelease,

    activityLst,
    activityDetail,
    activityEdit,
    activityRelease,
    activityDel,
    activityExamine,
    activityRecall,
    activitySetover,
    activityJoinlist,
    activityOperatelog,
    dictionaryGetactivitytype,
    activitySetsign,
    activityCanceljoin,


    channelLst,
    channelDetail,
    channelEdit,
    channelStopcooperation,
    channelCancel,
    channelOperatelog,
    channelCommissionlog,
    channelOrderlist,

    studyLst,
    studyDetail,
    studyEdit,
    studyDel,

    helpLst,
    helpHandle,
    helpDetail,
    helpHandlelist,
    dictionaryGethelptype,

    shopGoodslist,
    shopGoodsedit,
    shopGoodsdetail,
    shopAttrlist,
    shopAttredit,
    shopGoodsstatus,
    shopGoodsdel,
    dictionaryGetage,

    shopcatelist,
    shopGetcate,
    shopCateedit,
    shopCatestatus,
    shopCatedel,
    shopImportcate,

    shopOrderlist,
    shopOrderdetail,
    shopOrdercancel,
    shopOrdersend,
    shopOrdersend,
    shopOrderresend,
    dictionaryGetexpress,

    shopRefundorderlist,
    shopRefundorderdetail,
    shopRefundhandle,
    shopRefundconfirmgetgoods,
    shopRefundgetgoodshandle,

    shopCheckorderlist,
    shopSetcheck,
    shopCheckorderrecovery,

    shopSeckilllist,
    shopAddseckill,
    shopEditseckill,
    shopSetseckillstatus,
    shopSeckilldel,

    shopNewlist,
    shopAddnew,
    shopEditnew,
    shopSetnewstatus,
    shopNofeedel,

    shopNofeelist,
    shopAddnofee,
    shopEditnofee,
    shopSetnofeestatus,
    
    shopBannerlist,
    shopEditbanner,
    shopSetbannerstatus,
    shopBannerdetail,
    shopBannerdel,

    shopViplist,
    shopEipedit,

    couponLst,
    couponDetail,
    couponEdit,
    couponSetstatus,
    couponDel,

    noticeLst,
    noticeDetail,
    noticeEdit,
    noticeDel,

    authorizeLst,
    authorizeGetallmenu,
    authorizeEdit,
    authorizeDel,
    authorizeSetmenu,

    adminLst,
    adminEdit,
    adminDetail,
    adminDel,
    adminSetstatus,
    adminGetrole,

    integralSetconfig,
    integralGetconfig,
    
    dictionaryParamlist,
    dictionaryValuelist,
    dictionaryEditvalue,
    dictionaryDel,
    dictionarySetstatus,

    activerateSetconfig,
    activerateGetconfig,

    activerateSetshengming,
    activerateGetshengming,

    fenxiaoGetopencity,
    fenxiaoOpencity,
    fenxiaoSetfenxiaoconfig,
    fenxiaoGetfenxiaoconfig,
    
    fenxiaoCustomizelist,
    fenxiaoAddcustomize,
    fenxiaoEditcustomize,
    fenxiaoDelcustomize,

    fenxiaoCommissionyingloulist,
    fenxiaoCommissionyinglouedit,
    fenxiaoCommissionyingloudetail,
    fenxiaoCommissionyingloudel,
    fenxiaoCommissionshoplist,

    fenxiaoCashoutlist,
    fenxiaoCashoutexamine,
    fenxiaoCashoutupload,
    fenxiaoResetcashout,
    fenxiaoCashoutdetail,
    fenxiaoCashoutorderlist,
    fenxiaoOperatelog,

    salerLst,
    salerGetchannel,
    salerGetpinfo,
    salerDetail,
    salerEdit,
    salerMovepid,
    salerMovechannel,
    salerStopcooperation,
    salerBohui,
    salerShenhepass,
    salerKeepcooperation,
    salerDel,
    salerEditderegulation,
    salerDeregulationlist,
    salerCancelderegulation,
    salerUserlist,
    salerCashoutlog,
    salerChildlist,
    salerCommissionlog,
    salerOperatelog,

    indexUpdateaddup,
    userCommissionlog,
    userOrderlist,
    shopEvaluatelist,
    taskGettasklog,
    activitySetqrcode,
}